export function initNavigation() {
  const header      = document.querySelector('[data-site-header]');
  const toggle      = document.querySelector('[data-menu-toggle]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const stickyCta   = document.querySelector('[data-sticky-cta]');

  // ── Scroll glass effect & sticky CTA ──────────────────────────────────────
  function onScroll() {
    const scrolled = window.scrollY > 24;
    if (header) header.classList.toggle('is-scrolled', scrolled);

    if (stickyCta) {
      const contact   = document.getElementById('ajanlatkeres');
      const inContact = contact && contact.getBoundingClientRect().top < window.innerHeight - 100;
      stickyCta.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8 && !inContact);
    }
  }

  // ── Mobile menu open/close ─────────────────────────────────────────────────
  function closeMenu() {
    if (!header || !toggle || !mobilePanel) return;
    header.classList.remove('is-open');
    mobilePanel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle && header && mobilePanel) {
    toggle.addEventListener('click', () => {
      const open = !header.classList.contains('is-open');
      header.classList.toggle('is-open', open);
      mobilePanel.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });

    mobilePanel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  }

  // ── Desktop dropdowns (click-to-open) ─────────────────────────────────────
  document.querySelectorAll('.nav-item.has-dropdown').forEach((item) => {
    const btn  = item.querySelector('.dropdown-toggle');
    const menu = item.querySelector('.dropdown-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !item.classList.contains('is-open');

      // Close all other open dropdowns first
      document.querySelectorAll('.nav-item.is-open').forEach((other) => {
        if (other !== item) {
          other.classList.remove('is-open');
          other.querySelector('.dropdown-toggle')?.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  // Close desktop dropdowns when clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('.dropdown-toggle')?.setAttribute('aria-expanded', 'false');
    });
  });

  // ── Mobile dropdowns (click-to-expand) ────────────────────────────────────
  document.querySelectorAll('.mobile-dropdown-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const navItem = btn.closest('.mobile-nav-item');
      const subMenu = navItem?.querySelector('.mobile-dropdown-menu');
      if (!navItem || !subMenu) return;

      const open = !navItem.classList.contains('is-open');
      navItem.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        subMenu.removeAttribute('hidden');
      } else {
        subMenu.setAttribute('hidden', '');
      }
    });
  });

  // ── ESC closes everything ─────────────────────────────────────────────────
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeMenu();
    document.querySelectorAll('.nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('.dropdown-toggle')?.setAttribute('aria-expanded', 'false');
    });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}
